import AppInfo from '@/store/modules/AppInfo'
import Auth from '@/store/modules/Auth'
import BankSetting from '@/store/modules/BankSetting'
import Banner from '@/store/modules/Banner'
import Block from '@/store/modules/Block'
import CallLog from '@/store/modules/CallLog'
import CallSetting from '@/store/modules/CallSetting'
import Chat from '@/store/modules/Chat'
import FavList from '@/store/modules/FavList'
import Footprint from '@/store/modules/Footprint'
import FreePoint from '@/store/modules/FreePoint'
import MessageFileGallery from '@/store/modules/MessageFileGallery'
import MessageList from '@/store/modules/MessageList'
import MessageTemplate from '@/store/modules/MessageTemplate'
import MyData from '@/store/modules/MyData'
import MypageMenu from '@/store/modules/MypageMenu'
import Notice from '@/store/modules/Notice'
import NotificationSetting from '@/store/modules/NotificationSetting'
import Payment from '@/store/modules/Payment'
import Profile from '@/store/modules/Profile'
import Reward from '@/store/modules/Reward'
import Search from '@/store/modules/Search'
import SearchResultUser from '@/store/modules/SearchResultUser'
import Stamp from '@/store/modules/Stamp'
import Timeline from '@/store/modules/Timeline'
import TimelineDetail from '@/store/modules/TimelineDetail'
import TimelineIine from '@/store/modules/TimelineIine'
import TimelineUser from '@/store/modules/TimelineUser'
import TopUser from '@/store/modules/TopUser'
import User from '@/store/modules/User'
import WoPoint from '@/store/modules/WoPoint'

export default {
  AppInfo,
  Auth,
  BankSetting,
  Banner,
  Block,
  CallSetting,
  Chat,
  CallLog,
  FavList,
  FreePoint,
  Footprint,
  MessageFileGallery,
  MessageList,
  MessageTemplate,
  MyData,
  MypageMenu,
  Notice,
  NotificationSetting,
  Payment,
  Profile,
  Reward,
  Search,
  SearchResultUser,
  Stamp,
  Timeline,
  TimelineDetail,
  TimelineIine,
  TimelineUser,
  TopUser,
  User,
  WoPoint
}
